import * as React from "react";
import styles from "@styles/pages/openings/index.module.scss";
import SIInput from "@components/input/si-input";
import qs from "qs";
import {useState} from "react";
import {MultiSelect} from "react-multi-select-component";
import SILink from "@components/link/silink";
import {strapi} from "@api/Strapi";
import {format, parseISO} from "date-fns";

// @ts-ignore
function Openings({jobList, searchValue, currentPage,
                      showMore = false,
                      department = '',
                      jobType = '',
                      locations = ''
                  }) {


    /**
     * Drop down department list
     */
    const optionsDepartment = [
        {label: "accounting", value: "accounting"},
        {label: "administrative", value: "administrative"},
        {label: "customer success", value: "customer success"},
        {label: "human resources", value: "human resources"},
        {label: "research & development", value: "research & development"},
        {label: "production", value: "production"}
    ];

    /**
     * Drop down job type list
     */
    const optionsJobType = [
        {label: "full time", value: "full_time"},
        {label: "part time", value: "part_time"},
        {label: "remote", value: "remote"},
        {label: "contract", value: "contract"}
    ]

    /**
     * Drop down recipe type list
     */
    const optionsLocation = [
        {label: "california", value: "ca"},
        {label: "florida", value: "fl"},
        {label: "new york", value: "ny"},
        {label: "texas", value: "tx"},
    ]

    /**
     * Mean type selected item list
     */
    const [selectedDepartment, setSelectedDepartment] = useState(optionsDepartment.filter((item: any) => {
        return department.split(",").indexOf(item.value) > -1
    }));

    /**
     * Job type selected item list
     */

    const [selectedJobType, setSelectedJobType] = useState(optionsJobType.filter((item: any) => {
        return jobType.split(",").indexOf(item.value) > -1
    }));

    /**
     * Location selected item list
     */

    const [selectedLocation, setSelectedLocation] = useState(optionsLocation.filter((item: any) => {
        return locations.split(",").indexOf(item.value) > -1
    }));
    /**
     * On change of dropdown set title of the main button of department
     * @param selected
     * @param _options
     */
    const customValueRendererDepartment = (selected: any, _options: any) => {
        return "department"
    };

    /**
     * On change of dropdown set title of the main button of job type
     * @param selected
     * @param _options
     */
    const customValueRendererJobType = (selected: any, _options: any) => {
        return "job type"
    };

    /**
     * On change of dropdown set title of the main button of job type
     * @param selected
     * @param _options
     */
    const customValueRendererLocation = (selected: any, _options: any) => {
        return "location"
    };

    /**
     * search is used for store the value of the search input.
     */
    const [search, setSearch] = useState(searchValue);
    /**
     * The privacy policy page contain about the company privacy policy
     * The text are managed via 3 different styles and one for list.
     */
    return (
        <>
            <section className={styles.banner}>
                <div className={'details_container'}>
                    <div className={'sidr_text'}>sidr openings</div>
                    <h1 className={'title_text'}>make an impact</h1>
                    <div className={'description'}>Our role is to support talents and create the friendly, motivating
                        work environment for them to help us, in turn, achieve SIDR’s strategic objectives.
                    </div>
                </div>
            </section>
            <div className={styles.container}>
                <div className={'top_bar'}>
                    <div className={'inner_box'}>
                        <SIInput placeholder={'SEARCH FOR JOBS'} value={search ?? ''} type={'text'}
                                 onChange={(e: any) => {
                                     setSearch(e.currentTarget.value);
                                 }}>
                        </SIInput>
                        <button onClick={() => {

                            let queryParam = qs.parse(window.location.search, {ignoreQueryPrefix: true});
                            queryParam.searchKeywords = search;

                            let selectedDepartmentValues = selectedDepartment.map((item: any) => {
                                return item.value
                            });

                            let selectedJobTypeValues = selectedJobType.map((item: any) => {
                                return item.value
                            });

                            let selectedLocationsValues = selectedLocation.map((item: any) => {
                                return item.value
                            });
                            queryParam.department = selectedDepartmentValues.join(",");
                            queryParam.jobType = selectedJobTypeValues.join(",");
                            queryParam.locations = selectedLocationsValues.join(",");

                            window.location.href = `${window.location.pathname}?${qs.stringify(queryParam)}`;

                        }}><img alt={'search'}
                            src={'/assets/images/decorations/recipe_general/recipe_main_search_for_recipes_arrow.webp'}/>
                        </button>
                    </div>
                    <div className={'inner_box_select'}>
                        <MultiSelect hasSelectAll={false} disableSearch={true}
                                     options={optionsDepartment}
                                     value={selectedDepartment}
                                     onChange={setSelectedDepartment}
                                     labelledBy="department"
                                     valueRenderer={customValueRendererDepartment}
                                     overrideStrings={{
                                         "selectSomeItems": "department",
                                     }}
                        />
                        <MultiSelect hasSelectAll={false} disableSearch={true}
                                     options={optionsJobType}
                                     value={selectedJobType}
                                     onChange={setSelectedJobType}
                                     labelledBy="job_types"
                                     valueRenderer={customValueRendererJobType}
                                     overrideStrings={{
                                         "selectSomeItems": "job types",
                                     }}
                        />
                        <MultiSelect hasSelectAll={false} disableSearch={true}
                                     options={optionsLocation}
                                     value={selectedLocation}
                                     onChange={setSelectedLocation}
                                     labelledBy="locations"
                                     valueRenderer={customValueRendererLocation}
                                     overrideStrings={{
                                         "selectSomeItems": "locations",
                                     }}
                        />
                    </div>
                </div>
                {
                    jobList.length > 0 &&
                    <div className={'job_list'}>
                        {
                            jobList.map((item: any, index: number) => {
                                return (
                                    <a href={`/openings/${item.attributes.Link}`} key={'job-' + index}
                                       className={'job_box'}>
                                        <span className={'department'}>{item.attributes.Department}</span>
                                        <span className={'name'}>{item.attributes.Title}</span>
                                        <div className={'location_job_type_date'}>
                                            <span className={'location'}>{item.attributes.Country_State}</span>
                                            <div className={'dot'}></div>
                                            <span className={'job_type'}>{item.attributes.Job_Type}</span>
                                            <div className={'dot'}></div>
                                            <span
                                                className={'date'}>{format(parseISO(item.attributes.createdAt), 'LLL d, yyyy')}</span>
                                            <span
                                                className={'job_type_date'}>{item.attributes.Job_Type}, {format(parseISO(item.attributes.createdAt), 'LLL d, yyyy')}</span>
                                        </div>
                                    </a>)
                            })
                        }

                    </div>
                }
                {
                    showMore ?
                        <div className={'show_more'}>
                            <SILink classes={''} href={'#!'} onClick={() => {
                                currentPage = currentPage + 1;
                                let queryParam = qs.parse(window.location.search, {ignoreQueryPrefix: true});
                                queryParam.page = currentPage;
                                window.location.href = `${window.location.pathname}?${qs.stringify(queryParam)}`;
                            }}>show more</SILink>
                        </div> : <div style={{marginBottom: '100px'}}></div>
                }
                {
                    jobList.length == 0 &&
                    <div className={'empty'}>
                        <span>Sorry, no jobs found matching this criteria.</span>
                        <p>Try removing filters or refine your search.</p>
                    </div>
                }
            </div>
        </>
    )
}

export async function getServerSideProps(context: {
    query: { page: number; searchKeywords: string; department: string; jobType: string; locations: string; };
    resolvedUrl: string
}) {

    try {
        let seoDetails: any = {
            // title: `Openings | SIDR®`,
            url: context.resolvedUrl,
            // keyword: 'SIDR openings',
            // description: 'SIDR® Openings are to support talents and create the friendly, motivating work environment for them to help us, in turn, achieve SIDR’s strategic objectives.'
        }


        let currentPage = 1;
        let totalItemsCount = 0;
        const itemsCountPerPage = 5;
        let showMore = false;
        const {department, jobType, locations} = context.query;
        if (context.query.page) {
            currentPage = parseInt(String(context.query.page))
        }

        let jobList: any = []
        let queryObject: any = {
            fields: ["Title", "Department", "Job_Type", "Country_State", "createdAt"],
            pagination: {
                page: currentPage,
                pageSize: itemsCountPerPage
            },
            filters: {},
            sort: ['id:desc'],
        }
        if (context.query.searchKeywords != undefined) {
            queryObject.filters.Title = {$containsi: context.query.searchKeywords}
        }
        let orValues = [];

        if (department) {
            let departmentTypeValues = department.split(",");
            for (let i = 0; i < departmentTypeValues.length; i++) {
                orValues.push({
                    Department: {$contains: departmentTypeValues[i]}
                })
            }
        }

        if (jobType) {
            let jobTypeValues = jobType.split(",");
            for (let i = 0; i < jobTypeValues.length; i++) {
                orValues.push({
                    Job_Type: {$contains: jobTypeValues[i]}
                })
            }
        }

        if (locations) {
            let jobLocationsValues = locations.split(",");
            for (let i = 0; i < jobLocationsValues.length; i++) {
                orValues.push({
                    Country_State: {$contains: `"isoCode":"${jobLocationsValues[i]}"`}
                })
            }
        }

        //

        if (orValues.length > 0) {
            queryObject.filters.$or = orValues;
        }

        try {

            for (let i = 1; i <= currentPage; i++) {
                queryObject.pagination.page = i
                let query = qs.stringify(queryObject, {encodeValuesOnly: true});
                const response = await strapi.getJobList(query);
                if (response.status == 200 && response.data && response.data.data) {
                    showMore = response.data.meta.pagination.page != response.data.meta.pagination.pageCount && response.data.meta.pagination.total > 0
                    totalItemsCount = response.data.meta.pagination.total;
                    for (let j = 0; j < response.data.data.length; j++) {
                        let job = response.data.data[j];
                        job.attributes.Link = job.attributes.Title.replace(/[^a-zA-Z ]/g, "");
                        job.attributes.Link = job.attributes.Link.replaceAll(" ", "_");
                        job.attributes.Link = `${job.attributes.Link}-${job.id + 1000}`
                        let countryState = JSON.parse(job.attributes.Country_State);
                        job.attributes.Country_State = `${countryState.state.name}, ${countryState.country.name}`
                        jobList.push(job);
                    }

                }
            }
        } catch (e) {
            console.log(e)
        }
        return {
            props: {
                seoDetails,
                showMore,
                jobList,
                currentPage,
                totalItemsCount,
                department: department ?? '',
                jobType: jobType ?? '',
                locations: locations ?? '',
                searchValue: context.query.searchKeywords ?? null,
                itemsCountPerPage,
            }
        }
    } catch (e) {
        return {props: {}}
    }
}

export default Openings;
